<template>
    <div>
        抓取任务列表
    </div>
</template>
<script>
export default {
    name: 'TaskList',
    data() {
        return {
            title: '抓取任务列表'
        }
    }
}
</script>
<style scoped>

</style>
